// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","search_container":"Home_search_container__ZyM6s","search_form":"Home_search_form__1+mEg","post_detail":"Home_post_detail__CvCyc"};